import React from "react";

function PolygonBlockchainHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-7 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Build Scalable Solutions with OP Stack
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology empowers businesses to build scalable and
                    secure blockchain applications using the OP Stack, offering
                    seamless integration with the Ethereum ecosystem for
                    enhanced performance and lower costs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PolygonBlockchainHero;
